import { api } from 'shared/api'

import { hotmartSchemas } from './schemas'

export type { HotmartProductSchemaType } from './schemas'

export { hotmartProductSchema } from './schemas'

export const HotmartApi = {
  getProducts: api.account.createGet({
    url: 'integration/hotmart/getProducts',
    schemas: hotmartSchemas.getProducts,
    scope: 'integration',
    section: 'hotmart',
  }),
}
